import { RootState } from 'redux/store';

export const getFetchingSelector = (action: string) => (state: RootState) =>
  state.loader[action] || 'initial';
